import { api } from "./client";

// Internal accessor for the bearer-token getter set by AuthSynchronizer.jsx.
// We can't import getAccessToken from client.js directly because it's stored
// in a module-private closure, so we expose a tiny re-fetch path here.
let tokenFetcher = () => Promise.resolve(null);
export function setExportsTokenFetcher(fn) {
  tokenFetcher = fn;
}

/**
 * Download an admin CSV export. Resolves once the file is saved by the
 * browser; rejects with a readable Error if the API returns a non-2xx
 * (we do a best-effort JSON decode to surface the server's error message).
 *
 * @param {string} path  API path under /api (e.g. "/admin/exports/users.csv")
 *                       OR a full path starting with "/api/" — both accepted
 *                       so callers can pass whichever feels natural.
 * @param {string} filename  Suggested filename for the download dialog.
 */
export async function downloadAdminExport(path, filename) {
  const url = path.startsWith("/api/") ? path : `/api${path.startsWith("/") ? "" : "/"}${path}`;

  const token = await tokenFetcher();
  const res = await fetch(url, {
    method: "GET",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!res.ok) {
    let message = `Request failed: ${res.status}`;
    try {
      const body = await res.json();
      if (body?.error) message = body.error;
    } catch (_) {
      // body wasn't JSON — keep the default status message
    }
    throw new Error(message);
  }

  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Free memory after the browser has had a chance to start the download.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}

// Re-export so consumers can chain typical JSON calls + downloads from one import.
export { api };
